import './FileUploader.scss';

import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import { ButtonType, Colors } from '@fifth-gear-tech/common-components/dist/utils/StyledTheme';
import { Button } from '@fifth-gear-tech/common-components/dist/components';
import Logger from '@KrashidBuilt/common/utils/logger';

import api from '../../api';

const logger = new Logger('FileUploader');

class FileUploader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            uploading: false
        };

        this.fileRef = createRef();
    }

    onFileUpload = (file) => {
        const { onComplete = () => { }, onError = () => { }, id } = this.props;

        this.setState({ uploading: true }, async () => {
            const formData = new FormData();
            formData.append('file', file, file.name);
            try {
                const response = await api.checklists.uploadLogo(id, formData);
                this.setState({ uploading: false }, () => {
                    onComplete(response);
                });
            } catch (error) {
                logger.error(error);
                this.setState({ uploading: false }, () => {
                    onError(error);
                });
            }
        });
    };

    render() {
        return (
            <div className={'FileUploader'}>
                <div className={'input-container'}>
                    <input ref={this.fileRef} className={'input-file'} type={'file'} multiple accept={'image/*'} onChange={({ target: { files: [file] } }) => this.onFileUpload(file)} />

                    <Button
                        onClick={() => {
                            this.fileRef.current.click();
                        }}
                        label={'Upload new logo'}
                        type={ButtonType.Dashboard}
                        colorTheme={Colors.Green}
                        className={'uploadLogoButton'}
                    />
                </div>
            </div>
        );
    }
}

FileUploader.propTypes = {
    url: PropTypes.string.isRequired,
    onComplete: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    type: PropTypes.string,
    id: PropTypes.string
};

export default FileUploader;